import classNames from 'classnames';
import { Link, Text } from '@nerdwallet/currency';
import P from 'prop-types';
import Image from '~/app/components/image/image';
import styles from './keto-product-card.module.scss';

import UniversalContainer, {
  universalContainerPropTypes,
} from '../universal-container';

const WhyNerdsLoveIt = ({
  container,
  turnOnGroupedBorders,
  whyNerdsLoveItTitle,
  whyNerdsLoveItTitleIconUrl,
  whyNerdsLoveItText,
  whyNerdsLoveItMethodologyUrl,
  whyNerdsLoveItAvatarUrl,
}) => {
  const containerProps = {
    ...container,
    ...(!container?.backgroundColor && {
      backgroundColor: 'HEXCOLOR',
      hexColor: '#f2fbff',
    }),
  };
  return (
    <UniversalContainer {...containerProps}>
      <div
        className={classNames([
          styles.whyNerdsLoveIt,
          { [styles.whyNerdsLoveItBorder]: turnOnGroupedBorders },
        ])}
      >
        <div
          className={classNames([
            styles.whyNerdsLoveItAvatar,
            { [styles.fixEmptyAvatarPadding]: !whyNerdsLoveItAvatarUrl },
          ])}
        >
          {whyNerdsLoveItAvatarUrl && (
            <Image
              src={whyNerdsLoveItAvatarUrl}
              alt="why nerds love it icon"
              backgroundColor="transparent"
              loading="lazy"
              fetchPriority="low"
            />
          )}
        </div>
        <div>
          <Text component="h4" className="whyNerdsLoveItTitle">
            {whyNerdsLoveItTitle || 'WHY OUR NERDS LOVE IT'}
            {whyNerdsLoveItTitleIconUrl && (
              <Image
                src={whyNerdsLoveItTitleIconUrl}
                alt="why nerds love it icon"
                backgroundColor="transparent"
                loading="lazy"
                fetchPriority="low"
              />
            )}
          </Text>
          <Text component="p">{whyNerdsLoveItText}</Text>
          <Link
            className={styles.whyNerdsLoveItTextLink}
            target="_blank"
            href={whyNerdsLoveItMethodologyUrl}
          >
            Read our methodology &#10095;
          </Link>
        </div>
      </div>
    </UniversalContainer>
  );
};

WhyNerdsLoveIt.propTypes = {
  container: universalContainerPropTypes,
  whyNerdsLoveItTitle: P.string,
  whyNerdsLoveItTitleIconUrl: P.string,
  whyNerdsLoveItText: P.string,
  whyNerdsLoveItMethodologyUrl: P.string,
  turnOnGroupedBorders: P.bool,
  whyNerdsLoveItAvatarUrl: P.string,
};

export default WhyNerdsLoveIt;
